import Vue from 'vue';
import axios from 'axios'
import App from './App.vue';
import router from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue'
import * as Sentry from '@sentry/browser'
import VueMatomo from 'vue-matomo'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './theme/main-ltr/css/style.css'
import './theme/main-ltr/css/skin_color.css'

Vue.config.productionTip = false;

// configure axios
const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		// logout and reload page when we receive a 401 response
		if (error && error.response && error.response.status === 401) {
			if (store && store.state && store.state.loggedin) {
				store.commit('SET_LOGGEDIN', false);
				store.commit('SET_USER', null);
				window.location.reload();
			}
		}
		return Promise.reject(error);
	}
);

// make axios instance accessible via this.$axios in component
Vue.prototype.$http = axiosInstance;

Vue.use(BootstrapVue);

// vue moment
const moment = require('moment');
require('moment/locale/de');
Vue.use(require('vue-moment'), { moment });
// vue moment typescript integration is not so great, but it works :/
// @ts-ignore
Vue.moment().locale('de');

Sentry.init({
  dsn: 'https://5bc6d6702234483784b49204a388e710@sentry.io/1423535',
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV === 'production' && !window.location.href.includes('//localhost'),
  release: process.env.NODE_ENV === 'production' ? (process.env.VUE_APP_BUILD_COMMITHASH || '').substring(0, 8) : 'local',
  integrations: [new Sentry.Integrations.Vue({
    Vue,
    attachProps: true
  })]
});
Sentry.configureScope((scope) => {
  scope.setTag('app', 'adminapp');
});

Vue.use(VueMatomo, {
	// Configure your matomo server and site by providing
	host: 'https://analytics.raumkalender.com',
	siteId: 1,
	trackerFileName: 'matomo',
	router: null,
	enableLinkTracking: false,
	requireConsent: false,
	trackInitialView: true,
	disableCookies: false,
	enableHeartBeatTimer: false,
	heartBeatTimerInterval: 15,
	debug: false,
	userId: undefined,
	cookieDomain: undefined,
	domains: undefined,
	preInitActions: []
});

//Better logging format than vue-matomo
router.afterEach(( to, from ) => {
	(<any>window)._paq.push(['setReferrerUrl', from.path]);
	(<any>window)._paq.push(['setCustomUrl', to.path]);
	(<any>window)._paq.push(['setDocumentTitle', to.name]);
	(<any>window)._paq.push(['trackPageView'])
});


// // router and IE 11 workaround. see: https://github.com/vuejs/vue-router/issues/1911
// const IE11RouterFix = {
//   methods: {
//     hashChangeHandler: function(this: any) { this.$router.push(window.location.hash.substring(1, window.location.hash.length)); },
//     // @ts-ignore
//     isIE11: function() { return !!window.MSInputMethodContext && !!document.documentMode; }
//   },
//   mounted: function(this: any) { if ( this.isIE11() ) { window.addEventListener('hashchange', this.hashChangeHandler); } },
//   destroyed: function(this: any) { if ( this.isIE11() ) { window.removeEventListener('hashchange', this.hashChangeHandler); } }
// };

new Vue({
  // mixins: [IE11RouterFix],
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
